import React from 'react'
import cn from 'classnames'

import Typography from 'components/UI/Typography/Typography'

import QuestionLogo from './question_logo.svg'

import styles from './StickyBox.module.css'

export interface StickyBoxProps {
  titleText: string
  oritentation: 'left' | 'right'
}

const StickyBox: React.FC<StickyBoxProps> = ({
  titleText,
  oritentation,
  children,
  ...props
}) => (
  <div
    className={cn(styles.sticky, {
      [styles.stickyLeft]: oritentation === 'left',
      [styles.stickyRight]: oritentation === 'right',
    })}
    {...props}
  >
    <div className={styles.stickyRow}>
      <img className={styles.icon} src={QuestionLogo} alt="hd-read-more" />
      <Typography.BodyBold>{titleText}</Typography.BodyBold>
    </div>
    {children}
  </div>
)

export default StickyBox
